export var EColDefType;
(function (EColDefType) {
    EColDefType["AB_COL_DEF_BOOLEAN"] = "abColDefBoolean";
    EColDefType["AB_COL_DEF_STRING"] = "abColDefString";
    EColDefType["DATE"] = "date";
    EColDefType["TENOR"] = "tenor";
    EColDefType["AB_COL_DEF_DATE"] = "abColDefDate";
    EColDefType["INTEGER"] = "integer";
    EColDefType["AB_COL_DEF_NUMBER"] = "abColDefNumber";
    EColDefType["ID"] = "id";
    EColDefType["AMOUNT"] = "amount";
    EColDefType["AB_COL_DEF_NUMBER_ARRAY"] = "abColDefNumberArray";
    EColDefType["ABSOLUTE"] = "absolute";
    EColDefType["AMOUNT_FIXED_CURRENCY"] = "amount_fixed-currency";
    EColDefType["AMOUNT_BASE_CURRENCY"] = "amount_base-currency";
    EColDefType["AMOUNT_QUOTE_CURRENCY"] = "amount_quote-currency";
    EColDefType["PERCENTAGE"] = "percentage";
    EColDefType["BASIS_POINT"] = "basisPoint";
    EColDefType["NUMBER"] = "number";
    //getNumberAggregationTypes
    EColDefType["SUM"] = "sum";
    EColDefType["AVERAGE"] = "average";
    EColDefType["WEIGHTED_AVERAGE"] = "weightedAverage";
    //getAmountAggregationTypes
    EColDefType["AMOUNT_SUM"] = "amountSum";
    EColDefType["AMOUNT_AVERAGE"] = "amountAverage";
    EColDefType["AMOUNT_WEIGHTED_AVERAGE"] = "amountWeightedAverage";
    EColDefType["COPY"] = "copy";
    EColDefType["TECHNICAL"] = "technical";
})(EColDefType || (EColDefType = {}));
